<template>
  <li>
    <div
      v-if="isMoveBookModeEnabled && this.$route.path !== '/'"
      :class="{ select_book: isMoveBookModeEnabled, active: selected }"
      @click="selectThisBook"
    >
      <button type="button" class="btn_select_book"></button>
    </div>
    <div class="cover_wrap">
      <a class="thum_wrap" href="#" @click="handleClick">
        <img :src="book.img || book.thumbUrl" :alt="book.title + ` 책 표지`" />
        <img
          v-if="getRightDays === `대여기간 만료`"
          class="endDate"
          src="@/assets/images/book_end_date.png"
          alt="도서기간만료"
        />
        <img
          v-if="isEbookEvent"
          class="eventMark"
          src="@/assets/images/eventmark2.png"
          alt="이벤트마크"
        />
        <div
          v-show="purchaseLabel && library"
          :class="[
            purchaseLabel === '소장'
              ? 'free_label_2'
              : purchaseLabel === '증정본'
              ? 'free_label_3'
              : purchaseLabel === '체험판'
              ? 'free_label_4'
              : ''
          ]"
          class="free_label"
        >
          {{ purchaseLabel }}
        </div>
        <span v-if="book.hasNote === 'Y'" class="iconbox">
          <span class="meta_editer note active">
            <span class="an_t">노트</span>
          </span>
        </span>
      </a>
    </div>
    <div class="info_wrap">
      <div v-if="library" class="free_date_wrap">
        <div class="free_date">
          <p>
            <span v-show="book.readRate > 0" style="color: #fff803;">
              {{ book.readRate }}
            </span>
            <span v-show="book.readRate > 0"> %</span>
            <span v-show="book.readRate == '-'">0 %</span>
            진행중
          </p>
          <p class="dueDate_box">
            <span v-show="getRightDays" class="dueDate">
              {{ getRightDays }}
            </span>
            <br />
          </p>
        </div>
      </div>
      <div class="cite_author">
        <div class="topic_wrap">
          <a href="#" @click="handleClick">
            <h3 class="meta_title">{{ book.title || book.bookNm }}</h3>
          </a>
          <div class="more_wrap">
            <i ref="downBar" @click="moreList">
              <img src="@/assets/images/more_line.png" alt="더보기" />
            </i>
            <ul v-show="moreBox" class="list_wrap">
              <li class="confirm">
                <router-link
                  :to="{
                    name: `${library ? 'library_' : ''}book_detail`,
                    params: {
                      id: book.bookCd || book.id,
                      orderId: book.orderId
                    }
                  }"
                >
                  도서 정보 확인
                </router-link>
              </li>
              <li
                v-if="
                  responseData &&
                  responseData.data &&
                  responseData.data.result &&
                  responseData.data.result.exists
                "
                class="down"
                @click="supplementDown"
              >
                부록 다운로드
              </li>
              <li
                v-if="book.bookshelfTp === 'UBS'"
                class="delete"
                @click="deleteBook"
              >
                책장에서 삭제
              </li>
            </ul>
          </div>
        </div>
        <p v-if="displaySub" class="row">
          <span v-if="book.author" class="meta_author">{{ book.author }}</span>
          <span v-if="book.publisher" class="gap">/</span>
          <span v-if="book.publisher" class="meta_publisher">
            {{ book.publisher }}
          </span>
        </p>
      </div>
      <div class="book_desc" :class="{ 'hidden': !landscape }">
        {{ bookDescWithoutTag }}
      </div>
    </div>
  </li>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  UI_SELECT_BOOK,
  UI_UNSELECT_BOOK,
  BOOKSHELF_SUPPLEMENT_DOWNLOAD,
  SUPPLEMENT_STATUS,
  BOOKSHELF_BOOK_GET
} from '@/store/types'
export default {
  name: 'BaseShelfBook',
  props: {
    book: {
      type: Object,
      required: true
    },
    landscape: {
      type: Boolean,
      default: false
    },
    library: {
      type: Boolean,
      default: false
    },
    displaySub: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moreBox: false,
      responseData: false,
      bookToDelete: null,
      showDeleteModal: false,
      viewerLink: null
    }
  },
  computed: {
    ...mapGetters([
      'isMoveBookModeEnabled',
      'getSelectedLibraryBooks',
      'getSupplementExists'
    ]),
    purchaseLabel() {
      let x = false
      switch (this.book.purchaseTp) {
        case 'PMT':
          x = '소장'
          break
        case 'PRS':
          x = '증정본'
          break
        case 'RNT':
          x = '대여'
          break
        case 'GFT':
          x = '선물'
          break
        case 'CPN':
          x = '체험판'
          break
        case 'PFF':
          x = '무료'
          break
        default:
          x = '소장'
          break
      }
      return x
    },
    getRightDays() {
      let left = this.book.rightsDays
      if (left > 0) {
        let formatt = left.toString()

        return `${formatt}일 남음`
      } else if (left == 0) {
        return `오늘 만료`
      } else if (left == -1) {
        return `대여기간 만료`
      } else {
        return left
      }
    },
    selected() {
      return this.getSelectedLibraryBooks.find((e) => e === this.book.bookCd)
    },
    isEbookEvent() {
      let salePrice = this.book?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.salePrice
      let listPrice = this.book?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.listPrice
      if (salePrice < listPrice) {
        return true
      } else {
        return false
      }
    },
    ebookEvent() {
      if (this.isEbookEvent) {
        return this.book.bookPrice.ebook.options.find(
          (e) => e.optDesc === '대여(6개월)'
        )?.salePrice
      } else {
        return 0
      }
    },
    bookDescWithoutTag() {
      if (this.book.bookDesc != null) {
        let res = this.book.bookDesc
        const regdex = /<[^>]*>?/g
        let str = res.replaceAll(regdex, '')
        return str
      }
      return ''
    }
  },
  watch: {
    moreBox(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          document.addEventListener('click', this.handleOutsideClick)
        })
      } else {
        document.removeEventListener('click', this.handleOutsideClick)
      }
    }
  },
  async beforeMount() {
    this.responseData = await this.$store.dispatch(
      SUPPLEMENT_STATUS,
      this.book.bookCd
    )
  },
  methods: {
    openDeleteConfirmation() {
      this.$emit('open-delete-modal', this.book)
    },
    handleClick() {
      if (this.getRightDays === '대여기간 만료') {
        alert('이용 기간이 종료된 도서입니다.')
        return
      }
      const newWindow = window.open('', '_blank')
      const payload = { id: this.book.bookCd }
      this.$store
        .dispatch(BOOKSHELF_BOOK_GET, payload)
        .then((book) => {
          this.viewerLink = book.webViewerUrl
          if (newWindow) {
            newWindow.location.href = this.viewerLink
          }
        })
        .catch(() => {
          if (newWindow) {
            newWindow.close()
          }
        })
    },
    selectThisBook() {
      if (!this.selected) {
        this.$store.commit(UI_SELECT_BOOK, this.book.bookCd)
      } else {
        this.$store.commit(UI_UNSELECT_BOOK, this.book.bookCd)
      }
    },
    moreList() {
      this.moreBox = !this.moreBox
    },
    handleOutsideClick(event) {
      if (
        this.moreBox &&
        this.$refs.downBar &&
        !this.$refs.downBar.contains(event.target)
      ) {
        this.moreBox = false
      }
    },
    async supplementDown() {
      try {
        const bookCode = this.book.bookCd
        const response = await this.$store.dispatch(
          BOOKSHELF_SUPPLEMENT_DOWNLOAD,
          bookCode
        )
        const downloadUrl = response.downloadUrl
        if (!downloadUrl) {
          throw new Error('다운로드 URL을 찾을 수 없습니다.')
        }
        this.triggerDownload(downloadUrl)
      } catch (error) {
        alert('파일 다운로드에 실패했습니다. 다시 시도해주세요.')
      }
    },
    async deleteBook() {
      this.$emit('open-delete-modal', this.book)
    },
    triggerDownload(url) {
      const link = document.createElement('a')
      link.href = url
      link.download = ''
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    showDeleteConfirmation(book) {
      this.bookToDelete = book
      this.showDeleteModal = true
    }
  }
}
</script>
<style src="@/assets/css/meta_book_style.css" scoped></style>
<style lang="scss" scoped>
.free_label {
  background: #3a89ff;
  height: 18px;
  position: absolute;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 30%);
  left: 7px;
  top: 7px;
  border-radius: 6px;
  text-align: center;
  line-height: 17px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  padding: 0 8px;
  white-space: nowrap;
}
.free_label_2 {
  background: #ff6a85;
}
.free_label_3 {
  background: #aa6aff;
  padding: 0 4px;
}
.free_label_4 {
  background: #1cbf17;
  padding: 0 4px;
}
.free_date_wrap {
  height: 22px;
  background-color: #34ccbe;
  border-radius: 5px;
  border: 1px solid #707070;
  font-size: 11px;
  color: #fff;
  font-weight: 400;
  overflow: hidden;
  margin-bottom: 10px;
}
.free_date {
  text-align: center;
  p {
    line-height: 22px;
    display: inline-block;
    width: 50%;
  }
}
.dueDate_box {
  width: 100%;
  font-weight: 500;
  color: #ff1d00;
  background-color: #fff;
}
.cite_author {
  min-height: 60px;
}
.topic_wrap {
  display: flex;
  justify-content: space-between;
}
.meta_title {
  -webkit-line-clamp: 2 !important;
}
.more_wrap {
  position: relative;
  i {
    display: block;
    width: 19px;
    height: 19px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .list_wrap {
    position: absolute;
    top: 20px;
    right: 0;
    z-index: 1;
    width: 119px;
    padding: 10px 0;
    background: #fff;
    text-align: right;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    li {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px 13px;
      font-size: 13px;
      color: #676060;
      cursor: pointer;
      &.confirm::before {
        content: '';
        display: block;
        width: 17px;
        height: 17px;
        background: url('../../assets/images/self_book/ellipse.png') no-repeat;
        background-size: contain;
      }
      &.down::before {
        content: '';
        display: block;
        width: 17px;
        height: 17px;
        background: url('../../assets/images/self_book/vector.png') no-repeat;
        background-size: contain;
      }
      &.delete::before {
        content: '';
        display: block;
        width: 17px;
        height: 17px;
        background: url('../../assets/images/self_book/trash.png') no-repeat;
        background-size: contain;
      }
    }
  }
}
.eplist .thum_wrap .endDate {
  position: absolute;
  top: calc(50% - 35px);
  left: calc(50% - 35px);
  width: 70px;
  height: 70px;
}
.eplist .thum_wrap .eventMark {
  position: absolute;
  top: calc(55px);
  left: calc(100% - (40px - 2px));
  width: 40px;
  height: 36px;
}
.meta_price {
  font-size: 1.55em;
}
.meta_price dt {
  width: 60px;
}
.book_desc {
  margin-top: 30px;
  width: 40%;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.select_book {
  text-align: center;
  .btn_select_book {
    width: 20px;
    height: 20px;
    background: url('../../assets/images/checkbox_off.png') no-repeat;
  }
  &.active {
    .btn_select_book {
      background: url('../../assets/images/checkbox_on.png') no-repeat;
    }
  }
}
@media all and (max-width: 767px) {
  .row {
    display: none;
  }
  .meta_author,
  .meta_publisher {
    font-size: 13px;
    line-height: 15px;
  }
  .meta_author,
  .meta_publisher {
    height: 18px;
  }
  .cite_author {
    min-height: 30px;
  }
}
@media (max-width: 480px) {
  .cite_author {
    min-height: 25px;
  }
}
</style>
